<template>
    <div>
        <div class="flex flex-col">
            <div
                id="title-general"
                class="flex flex-col md:flex-row justify-between items-center"
            >
                <div class="flex justify-between items-center">
                    <router-link
                        to="/app/supply-lists"
                        class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                    >
                        <span>🏠</span>
                    </router-link>

                    <div class="flex text-center">
                        <h1 v-if="id" class="text-3xl capitalize">
                            &nbsp; Detalle de lista de compras #{{ id }} para
                            {{ merchant.type | merchantInfo("type") }}
                            <span class="text-theme-primary">
                                {{ merchant.name }}
                            </span>
                        </h1>
                        <h1 v-else class="text-3xl capitalize">
                            &nbsp; Registrar lista de compras pendientes para
                            {{
                                selectedMerchant.merchantType
                                    | merchantInfo("type")
                            }}
                            <span class="text-theme-primary">
                                {{ selectedMerchant.name }}
                            </span>
                        </h1>
                    </div>
                </div>

                <custom-switch
                    v-if="$ability.hasPermission('supplyList:Update') && id"
                    v-model="enabledUpdate"
                >
                    <span class="text-theme-inverse">🖊</span>
                </custom-switch>
            </div>
        </div>

        <div v-if="appliedAt" class="flex flex-wrap mt-3">
            <div class="bg-yellow-200 px-3 py-2 rounded-md">
                <span>
                    Ten presente que ya has efectuado esta lista de compras el
                    día
                    {{ appliedAt }}. Puedes efectuar la lista de compras la
                    cantidad de veces que lo requieras, sin embargo, te
                    recomendamos clonar la lista de compras y aplicar la nueva
                    lista.
                </span>
            </div>
        </div>

        <div class="flex flex-wrap mt-2">
            <div v-if="id" class="w-full my-3 p-0 flex justify-around">
                <span class="text-left"> 📆💾 {{ createdAt | date }} </span>
                <span class="text-left"> 📆✏ {{ updatedAt | date }} </span>
                <small v-if="appliedAt" class="text-left">
                    Fecha de último paso a inventario {{ appliedAt | date }}
                </small>
            </div>
            <div class="w-full">
                <span>
                    para llevar un control más eficiente de los productos que
                    necesitas abastecer en tu inventario, es recomendable crear
                    listas de compras. Además, una vez creadas estas listas de
                    compras, podrás utilizarlas varias veces para registrar los
                    mismos productos en tu inventario. Esto te permitirá ahorrar
                    tiempo y asegurarte de no olvidar ningún producto importante
                    en tus compras.
                </span>
            </div>
        </div>

        <div class="flex flex-wrap">
            <div class="md:w-1/2 w-full px-2 mt-5 flex flex-col">
                <div class="flex items-center justify-between">
                    <strong>Concepto</strong>
                    <custom-tooltip border>
                        <app-button icon circle border> ℹ </app-button>
                        <template #tooltip>
                            El concepto es un recordatorio para ti. Puedes
                            registrar una descripción de los productos que vas a
                            comprar o cualquier otro concepto que te ayude a
                            identificar la lista de compras.
                        </template>
                    </custom-tooltip>
                </div>
                <custom-input
                    v-model="concept"
                    type="text"
                    placeholder="Cuadernos y blogs"
                    class="w-full"
                    :disabled="!enabledUpdate"
                    :error="
                        !isValidConcept & introValidators.concept
                            ? 'El concepto debe tener mínimo un caracter'
                            : ''
                    "
                    @focus="onFocusSomeInput"
                    @blur="onBlurConcept"
                />
            </div>
            <div class="md:w-1/2 w-full px-2 mt-14">
                <supplier-selector
                    v-model="supplier"
                    :enabled="enabledUpdate"
                    :allow-create="enabledUpdate"
                    fill
                />
            </div>
            <!-- <div
                class="w-full md:w-1/2 mt-8 flex flex-col justify-between"
            >
                <div class="flex items-center justify-between">
                    <strong>Fecha de recordatorio (Opcional) </strong>
                    <custom-tooltip border>
                        <app-button icon circle border> ℹ </app-button>
                        <template #tooltip>
                            Estamos trabajando para que te recibas un mensaje al
                            canal de Telegram del tiendael día del
                            recordatorio.
                        </template>
                    </custom-tooltip>
                </div>
                <date-picker
                    v-model="notifyAt"
                    locale="es"
                    size="md"
                    :min="minDate"
                    :disabled="!enabledUpdate"
                ></date-picker>
            </div> -->
        </div>

        <div
            v-show="enabledUpdate"
            class="flex flex-wrap mt-5 flex-col justify-center items-center"
        >
            <h3 class="text-lg">
                Selecciona las referencias que deseas comprar
            </h3>
            <inventories-search-scanner
                v-if="enabledUpdate"
                :enabled-scanner="enabledScanner"
                @input="validatePushReferences"
            >
                <template #complement>
                    <product-anonymous-button
                        introduction="Puedes guardar productos aún no registrados en tu lista de compras para usarlos como recordatorio. Una vez los hayas comprado debes crear el producto para posteriormente hacer el ingreso del producto al inventario del producto."
                        label-value="Costo estimado"
                        :value-required="false"
                        label-concept="Nombre del producto"
                        label-quantity="Stock Requeridas"
                        @input="selectProductAnonymous"
                        @open="onFocusSomeInput"
                        @close="enabledScanner = true"
                        @focus="onFocusSomeInput"
                    />
                </template>
            </inventories-search-scanner>
        </div>

        <div class="flex flex-col z-0 mt-3 mb-4 min-h-72">
            <div class="w-full">
                <h4 v-show="references.length" class="mt-3">Variantes</h4>
                <reference-inventory-items
                    v-for="(reference, index) in references"
                    :key="'A' + index"
                    :enabled="enabledUpdate"
                    class="md:w-11/12 w-full mx-auto"
                    :reference="reference"
                    @update="changeReference"
                    @remove="removeReference"
                    @focus="onFocusSomeInput"
                    @blur="onBlurSomeInput"
                />
            </div>
            <div class="w-full">
                <h4 v-show="anonymousReferences.length" class="mt-4 mb-2">
                    Variantes anónimas
                </h4>
                <reference-table-item
                    v-for="(reference, index) in anonymousReferences"
                    :key="'B' + index"
                    :reference="reference"
                    :enabled="enabledUpdate"
                    class="md:w-11/12 w-full mx-auto"
                    @update="changeQuantityAnonymousReference"
                    @remove="removeAnonymousReference"
                    @focus="onFocusSomeInput"
                    @blur="onBlurSomeInput"
                />
            </div>
        </div>

        <div class="flex z-0 mb-4">
            <div class="w-full flex justify-center">
                <div v-if="id" class="flex justify-between items-center">
                    <app-button
                        v-if="$ability.hasPermission('supplyList:Apply')"
                        color="#d33ddd"
                        size="large"
                        @click="openModalApply"
                    >
                        Efecturar lista de compras
                    </app-button>
                    <app-button
                        v-if="enabledUpdate"
                        size="large"
                        @click="updateItemComponent"
                    >
                        Actualizar lista de compras
                    </app-button>
                </div>
                <app-button v-else size="large" @click="createItemComponent">
                    Crear lista de compras
                </app-button>
            </div>
        </div>

        <app-dialog v-model="isOpenModalApply">
            <template #header>
                <div class="flex flex-col">
                    <div class="mx-4 mt-2 flex flex-col lg:flex-row">
                        <h3 class="text-center">
                            ¿ Quieres Aplicar La lista de compras ?
                        </h3>
                    </div>
                </div>
            </template>
            <div>
                <p>
                    Cuando efectuas la lista de compras pasas las referencias de
                    tu lista de compras al inventario.{{
                        $enabledEcommerceOptions
                            ? "Opcionalmente puedes adjuntar la factura para posteriormente hacer uso de ella en tu reporte fiscal."
                            : ""
                    }}
                </p>
                <ul class="list-group">
                    <li
                        v-if="anonymousReferences.length"
                        class="bg-yellow-200 px-3 rounded-md"
                    >
                        <span>
                            No se registrarán los productos anónimos al
                            inventario.
                        </span>
                    </li>
                    <li v-if="appliedAt" class="bg-yellow-200 px-3 rounded-md">
                        <span>
                            Ya se ha efectuado la lista de compras el día
                            {{ appliedAt }}. Si así lo desea, puede volver a
                            realizarla.
                        </span>
                    </li>
                </ul>
                <div class="flex flex-col">
                    <custom-checkbox
                        v-if="$enabledEcommerceOptions"
                        v-model="needBill"
                        warn
                    >
                        <span class="text-center">
                            Adjuntar factura de tu compra (Opcional)
                        </span>
                    </custom-checkbox>
                    <div
                        v-if="needBill"
                        class="w-full mt-3 flex justify-center"
                    >
                        <private-file-uploader
                            v-model="receiptFile"
                            auto-approve
                            auto-loader
                        />
                    </div>
                    <div class="flex justify-center">
                        <app-button color="#d33ddd" @click="applyItemComponent">
                            Efecturar lista de compras
                        </app-button>
                    </div>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapActions, mapGetters, mapState } from "vuex";

import { titleRegex } from "@/common/lib/regex";

import InventoriesSearchScanner from "@/components/inventories/InventoriesSearchScanner.vue";
import ProductAnonymousButton from "@/components/products/ProductAnonymousButton.vue";
import ReferenceInventoryItems from "@/components/references/ReferenceInventoryItems.vue";
import ReferenceTableItem from "@/components/references/ReferenceTableItem.vue";
import SupplierSelector from "@/components/suppliers/SupplierSelector.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import PrivateFileUploader from "@/components/utils/PrivateFileUploader.vue";

export default {
    name: "SupplyListDetails",
    components: {
        AppDialog,
        PrivateFileUploader,
        ReferenceTableItem,
        ProductAnonymousButton,
        ReferenceInventoryItems,
        InventoriesSearchScanner,
        SupplierSelector,
        CustomInput
    },
    data: () => ({
        id: 0,
        total: 0,
        concept: "",
        isOpenModalApply: false,
        enabledUpdate: false,
        needBill: false,
        notifyAt: "",
        appliedAt: "",
        updatedAt: "",
        createdAt: "",
        enabledScanner: false,
        minDate: DateTime.now().toFormat("yyyy-MM-dd"),
        anonymousReferences: [],
        references: [],
        receiptFile: { url: "", name: "" },
        merchant: { name: "", id: "" },
        supplier: { slug: "", name: "indefinido" },
        introValidators: {
            concept: false
        }
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor", "stateInputDark"]),
        isValidConcept() {
            return titleRegex.test(this.concept);
        },
        stateEnabled() {
            return this.enabledUpdate ? this.stateInputDark : "";
        }
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if ("id" in this.$route.params) {
            if (
                !(await verifyPagePermission(
                    "supplyList:Get",
                    "/app/supply-lists"
                ))
            )
                return;
            const id = Number(this.$route.params.id);
            this.id = id;

            await this.getBaseItem({
                id,
                merchantId: this.$route.query.merchantId,
                merchantType: this.$route.query.merchantType
            });
        } else if ("idClone" in this.$route.params) {
            if (
                !(await verifyPagePermission(
                    "supplyList:Create",
                    "/app/supply-lists",
                    true
                ))
            )
                return;

            this.id = 0;
            this.enabledUpdate = true;

            await this.getBaseItem({
                id: Number(this.$route.params.idClone),
                merchantId: this.$route.query.merchantId,
                merchantType: this.$route.query.merchantType
            });

            this.concept = `${this.concept} CLONE`;
            this.notifyAt = "";
            this.appliedAt = "";
            this.$swal.fire({
                background: this.backgroundColor,
                title: "Estas clonando una lista de compras",
                icon: "info",
                showCloseButton: true
            });
        } else {
            if (
                !(await verifyPagePermission(
                    "supplyList:Create",
                    "/app/supply-lists",
                    true
                ))
            )
                return;
            this.enabledUpdate = true;
            this.enabledScanner = true;
        }
    },
    methods: {
        ...mapActions("supplyLists", [
            "getSupplyListById",
            "updateSupplyList",
            "createSupplyList",
            "applySupplyList"
        ]),
        async getBaseItem({ id, merchantId, merchantType }) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const {
                    anonymousReferences,
                    appliedAt,
                    concept,
                    createdAt,
                    merchant,
                    notifyAt,
                    references,
                    supplier,
                    updatedAt
                } = await this.getSupplyListById({
                    id,
                    merchantId,
                    merchantType
                });
                this.concept = concept;
                this.notifyAt = notifyAt;
                this.createdAt = createdAt;
                this.updatedAt = updatedAt;
                this.appliedAt = appliedAt
                    ? DateTime.fromJSDate(new Date(appliedAt))
                          .setZone(this.timezone)
                          .setLocale("es-CO")
                          .toFormat("cccc, LLLL dd / HH:mm")
                    : "";
                this.merchant = { ...merchant };
                if (supplier) {
                    this.supplier = { ...supplier };
                }
                this.references = [...references];
                this.anonymousReferences = [...anonymousReferences].map(
                    (item) => ({ ...item, priceOffer: item.cost })
                );
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/supply-lists");
                }
            }
        },
        async updateItemComponent() {
            if (!this.validateData()) {
                return;
            }

            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateSupplyList({
                    ...this.getDataSend(),
                    merchantId: this.merchant.id,
                    merchantType: this.merchant.type
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async createItemComponent() {
            if (!this.validateData()) {
                return;
            }
            this.isLoading = true;
            this.$loading.show();
            try {
                const data = await this.createSupplyList({
                    ...this.getDataSend(),
                    merchantId: this.selectedMerchant.merchantId,
                    merchantType: this.selectedMerchant.merchantType
                });
                this.$loading.hide();
                this.$sound.play();
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Creación exitosa",
                    text: "Puedes continuar editando los productos o el concepto de la lista de compras",
                    icon: "success",
                    showDenyButton: true,
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: "#02672D",
                    cancelButtonColor: "#253C99",
                    denyButtonColor: "#d33ddd",
                    confirmButtonText: "Ver detalle",
                    denyButtonText: "Ir a lista de Lista de comprass",
                    cancelButtonText: "Nueva lista de compras"
                });
                this.id = data.id;
                if (dialogResult.isConfirmed) {
                    this.id = data.id;
                    this.$router.push(`/app/supply-lists/detail/${this.id}`);
                }
                if (dialogResult.isDenied) {
                    this.$router.push("/app/supply-lists/");
                }
                if (dialogResult.isDismissed) {
                    this.introValidators = {
                        concept: false
                    };
                    this.concept = "";
                    this.references = [];
                }
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async applyItemComponent() {
            this.isLoading = true;
            this.isOpenModalApply = false;
            this.$loading.show();
            try {
                const { appliedAt } = await this.applySupplyList({
                    ...this.getDataSend(),
                    merchantId: this.merchant.id,
                    merchantType: this.merchant.type
                });
                this.appliedAt = appliedAt;
                this.$sound.play();
                this.$loading.hide();
                this.isOpenModalApply = false;
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Registro de inventario exitoso",
                    text: "Redirigiendo a home ...",
                    icon: "success",
                    showCloseButton: true,
                    timer: 10000,
                    confirmButtonColor: "#02672D"
                });
                this.$router.push("/app/inventories/history");
            } catch (error) {
                this.$loading.hide();
                this.isOpenModalApply = false;
                this.isLoading = false;
                this.$sound.play("error");
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        openModalApply() {
            if (!this.validateData()) {
                return;
            }
            this.isOpenModalApply = true;
        },
        validateData() {
            this.introValidators = {
                concept: true
            };

            const toComplete = [];
            if (!this.isValidConcept) {
                toComplete.push("Concepto");
            }

            if (!this.references.length && !this.anonymousReferences.length) {
                toComplete.push("Variantes");
            }

            if (toComplete.length) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Variante invalida",
                    text: `Revisa por favor que todo este completo. Valida los siguientes campos: ${toComplete.join(
                        ", "
                    )}`,
                    icon: "info"
                });
                return false;
            }
            return true;
        },
        getDataSend() {
            return {
                id: this.id,
                concept: this.concept,
                receiptFile: this.receiptFile,
                supplierId: this.supplier?.id,
                ...{
                    ...(this.notifyAt
                        ? {
                              notifyAt: this.notifyAt
                          }
                        : null)
                },
                references: this.references.map((item) => ({
                    id: item.id,
                    quantity: item.quantity,
                    costNew: item.costNew
                })),
                anonymousReferences: [...this.anonymousReferences]
            };
        },
        validatePushReferences(reference) {
            const index = this.references.findIndex(
                (item) => item.id === reference.id
            );

            if (index === -1) {
                this.references.unshift({ ...reference, quantity: 1 });
            } else {
                let references = [...this.references];
                references[index] = {
                    ...references[index],
                    quantity: references[index].quantity + 1
                };
                this.references = [...references];
            }
        },
        changeReference({ costNew, id, priceNew, quantity }) {
            const index = this.references.findIndex((item) => item.id == id);
            let references = [...this.references];
            references[index] = {
                ...references[index],
                quantity,
                priceNew,
                costNew
            };
            this.references = [...references];
        },
        removeReference({ id }) {
            const index = this.references.findIndex((item) => item.id == id);
            let references = [...this.references];
            references.splice(index, 1);
            this.references = [...references];
        },
        selectProductAnonymous({ priceOffer, product, quantity }) {
            this.anonymousReferences.push({
                cost: priceOffer,
                priceOffer,
                quantity,
                product
            });
        },
        changeQuantityAnonymousReference({ id, quantity }) {
            const index = this.anonymousReferences.findIndex(
                (item) => item.id == id
            );
            let anonymousReferences = [...this.anonymousReferences];
            anonymousReferences[index] = {
                ...anonymousReferences[index],
                quantity
            };
            this.anonymousReferences = [...anonymousReferences];
        },
        removeAnonymousReference({ id }) {
            const index = this.anonymousReferences.findIndex(
                (item) => item.id === id
            );
            let anonymousReferences = [...this.anonymousReferences];
            anonymousReferences.splice(index, 1);
            this.anonymousReferences = [...anonymousReferences];
        },
        onBlurConcept() {
            this.introValidators.concept = true;
            this.onBlurSomeInput();
        },
        onBlurSomeInput() {
            this.enabledScanner = true;
        },
        onFocusSomeInput() {
            this.enabledScanner = false;
        }
    }
};
</script>
